import refreshTokenService from "./refreshTokenService";
import authenService from "./authenService";

export async function refreshTokenInternal() {
  try {
    const response = await refreshTokenService.refreshSSO();
    // const response = await refreshTokenService.refresh();
    if (response.status !== 200) {
      console.log("refreshTokenInternal log out " + response.status);
    } else {
      // console.log("refreshTokenInternal id_token " + response.data.id_token);
      await authenService.saveNewIDToken(response.data.id_token);
    }
  } catch (error) {
    // console.log(error.response.data);
    console.log("catch log out");
  }
}

export function refreshTokenBeforeRedirect() {
  try {
    const response = refreshTokenService.refreshSSO();
    // const response = await refreshTokenService.refresh();
    if (response.status !== 200) {
      console.log("refreshTokenInternal log out " + response.status);
    } else {
      // console.log("refreshTokenInternal id_token " + response.data.id_token);
      authenService.saveNewIDToken(response.data.id_token);
    }
  } catch (error) {
    console.log("catch log out");
  }
}

export async function refreshToken() {
  console.log("refreshToken Interval ignore");
  try {
    const intervalName = setInterval(async () => {
      await refreshTokenInternal();
    }, intervalMilliSeconds);
    console.log("refreshToken setIntervalName: " + intervalName);
  } catch (error) {
    console.log("refreshToken log out");
  }
}

export const intervalMilliSeconds = 1680000; // 28 minutes



// WEBPACK FOOTER //
// ./src/services/refreshTokenUtils.js